import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

export const Wrapper = styled(Container)`
	&.PersonalBlock{
		/*width: 100%;
    display: flex;*/
    margin-top: 103px;
	}
	&.Block{
		width: 50%;
	}
`;

export const H2Personal = styled.h2`
	margin-bottom: 78px;
	font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 36px;
	line-height: 135%;
	color: #2C2B48;
`;

export const Paragraph = styled.p`
	margin-bottom: 78px;
	font-family: OpenSans, Helvetica, "Helvetica Neue", sans-serif;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 30px;
	color: #808387;
  @media screen and (min-width: 768px) {
    font-size: 18px;
  }
`;

export const StyledImg = styled.img`
	width: 100%;
`;

export const StyledBtn = styled(Button)`
	width: 246px;
	height: 72px;
	background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
	border-radius: 8px;
	font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	line-height: 136%;
	text-align: center;
	color: #FFFFFF;
	display: flex;
	justify-content: center;
	align-items: center;
	border: none;
	&:hover{
		background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
		box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
		color: #FFFFFF;
		border: none;
	}
	&:focus{
		color: #FFFFFF;
		border: none;
		background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
		box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
	}
`;
